import React from 'react';
import ReactDOM from 'react-dom';

import OutlinedExportButton from '../components/OutlinedExportButton';

/**
 * The element beside the "Analytics" page title. Each tab puts its Export
 * button there instead of positioning it by hand (CP-8289). Null when a tab
 * is rendered outside the Analytics page.
 */
export const AnalyticsHeaderSlotContext = React.createContext(null);

/**
 * Export for an Analytics tab: in the title row on every screen size,
 * otherwise where `anchorStyle` pins it. Desktop used to pin it with
 * position:fixed, so once the Ratings charts and the Agent Metrics summary
 * made those pages scroll it floated over their filters (CP-5220, Rea
 * 2026-10-30); in the title row it scrolls away with the page.
 */
export const AnalyticsExportButton = ({ isSmallScreen, anchorStyle, ...props }) => {
    const slotEl = React.useContext(AnalyticsHeaderSlotContext);
    if (slotEl) {
        return ReactDOM.createPortal(<OutlinedExportButton {...props} />, slotEl);
    }
    return <OutlinedExportButton {...props} anchorStyle={anchorStyle} />;
};
